export const colors = {
  //Black
  black: '#000000',

  //White
  white: '#FFFFFF',

  //Green
  green: '#88ff88',
  green1: '#F6FFED',
  green2: '#B7EB8F',
  green10: '#EBFFEB',
  green20: '#f6fff6',
  green40: '#CFFFCF',
  green50: '#A0FFA0',
  green100: '#ebffeb',
  green200: '#d4ffd4',

  //Yellow
  yellow: '#FFFF00',

  //Red
  red1: '#FFF1F0',
  red3: '#FFA39E',
  red10: '#FEF1F3',
  red30: '#F23054',
  red50: '#f23054',

  //Blue
  blue60: '#4683F3',

  //Orange
  orange: '#ff7941',
  oranageSecondary: '#FF7840',

  //Grey
  grey10: '#F6F7F7',
  grey30: ' #D2D2D2',
  newGrey10: '#E8E8E8',
  grey20: '#E8E8EA',
  grey60: '#606060',
  grey90: '#1A1A1A',
  grey80: '#525B60',
};
